package diana.soleil.design.iraniancanadienbazzar.core.firebase

/** An image re-encoded for upload: [bytes] plus the MIME type they were encoded as. */
internal class CompressedImage(val bytes: ByteArray, val contentType: String)

/**
 * Decodes [bytes], downscales so the longest side is at most [maxDimension] px, and re-encodes as
 * JPEG at [quality] (0–100). Returns null when the bytes cannot be decoded (corrupt or unsupported
 * format) — callers fall back to uploading the original bytes.
 */
internal expect suspend fun downscaleImage(
    bytes: ByteArray,
    maxDimension: Int,
    quality: Int,
): CompressedImage?
